<div class="row mt-5">
  <div class="col-12">
    <h2 id="shareClassShareholderDistribution">Distributions</h2>

    <table class="table mb-2">
      <thead class="table-light">
        <tr>
          <th>Actionnaire</th>
          <th>Nombre d'actions détenues</th>
          <th>Prix de base rajusté</th>
          <th>Capital versé</th>
          <th>Juste valeur marchande</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        @for (shareClassShareholderDistribution of this.shareClassShareholderDistribution.formGroups; track shareClassShareholderDistribution; let i = $index) {
          <tr>
            <td>
              <magieno-dynamic-select
                [advancedFormControl]="this.getShareholderId(shareClassShareholderDistribution)"
                [items]="this.getShareholdersSelectKeyValues()"
                [showTitle]="false"
              ></magieno-dynamic-select>
            </td>
            <td>
              <magieno-input-number-field
                [advancedFormControl]="getNumberOfSharesOwned(shareClassShareholderDistribution)"
              [showTitle]="false"></magieno-input-number-field>
            </td>
            <td>
              <magieno-input-money-field [advancedFormControl]="getAdjustedCostBase(shareClassShareholderDistribution)"
                [currency]="this.currency"
                [locale]="this.locale"
              [showTitle]="false"></magieno-input-money-field>
            </td>
            <td>
              <magieno-input-money-field [advancedFormControl]="getPaidUpCapital(shareClassShareholderDistribution)"
                [currency]="this.currency"
                [locale]="this.locale"
              [showTitle]="false"></magieno-input-money-field>
            </td>
            <td>
              <magieno-input-money-field [advancedFormControl]="getFairMarketValue(shareClassShareholderDistribution)"
                [currency]="this.currency"
                [locale]="this.locale"
              [showTitle]="false"></magieno-input-money-field>
            </td>
            <td>
              <div class="dropdown d-flex" style="width: fit-content">
                <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle d-block text-center"
                  data-bs-toggle="dropdown"
                  data-expanded="false" href="#" role="button">
                  <i class="fe fe-more-vertical"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a (click)="removeShareClassShareholderDistribution(shareClassForm, i); $event.preventDefault()"
                    class="dropdown-item"
                    href="#"
                    id="remove_share_class_{{ shareClassIndex }}_shareholder_distribution_{{ i }}">
                    Supprimer
                  </a>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <a (click)="this.addShareClassShareholderDistribution();$event.preventDefault()"
      [id]="'add_share_class_' + shareClassIndex + '_shareholder_distribution'" class="btn btn-primary ms-3"
      href="#shareClassShareholderDistribution">
      + Ajouter une distribution
    </a>

  </div>
</div>